module.exports = __webpack_public_path__ + "5f05fbc12ebf3ee1666d00b6938f6c15.svg";